import { createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "feedbackModal",
  tabindex: "-1",
  "aria-labelledby": "feedbackModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "feedbackModalLabel"
}, "Give Feedback", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { for: "" }, "Title", -1)
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { for: "" }, "Description", -1)
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { for: "" }, "Upload File", -1)
const _hoisted_15 = { class: "custom-file" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", {
  class: "custom-file-label",
  for: "customFile"
}, "Choose file", -1)
const _hoisted_17 = {
  key: 0,
  class: "img-wrap"
}
const _hoisted_18 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("button", {
              type: "button",
              class: "close",
              "aria-label": "Close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.issueDataClear && _ctx.issueDataClear(...args)))
            }, [
              _hoisted_7
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_ErrorList, {
              errors: _ctx.state.error.erorList.errorsList,
              hasError: _ctx.state.error.hasError
            }, null, 8, ["errors", "hasError"]),
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.title = $event))
              }, null, 512), [
                [_vModelText, _ctx.state.data.title]
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createVNode("textarea", {
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.description = $event))
              }, null, 512), [
                [_vModelText, _ctx.state.data.description]
              ])
            ]),
            _createVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode("div", _hoisted_15, [
                _createVNode("input", {
                  type: "file",
                  accept: "*.*",
                  id: "create-user-issue",
                  class: "custom-file-input",
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onCurrentIssueUpload($event)))
                }, null, 32),
                _hoisted_16
              ]),
              (_ctx.state.data.file)
                ? (_openBlock(), _createBlock("div", _hoisted_17, [
                    _createVNode("img", {
                      src: _ctx.state.data.file,
                      alt: ""
                    }, null, 8, ["src"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("button", {
              type: "button",
              class: "btn default-btn",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.createUserIssue && _ctx.createUserIssue(...args)))
            }, _toDisplayString(_ctx.state.ui.isPostLoading.createUserIssue
                  ? "Submitting..."
                  : "Submit"), 1)
          ])
        ])
      ])
    ])
  ]))
}